import { Injectable } from '@angular/core';
import { ApiClientService } from 'api-services';
import { Observable } from 'rxjs';
import { AuthService } from 'services';
import { ProductInfo } from '../models/product.model';
import { TenantPaymentInfo } from '../models/tenant-payment-info.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {  
  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService
  ) {}

  public getProductPrice(): Observable<TenantPaymentInfo> {
    return this.apiClient.get('api/payment/getProductPrice', null, null, true);
  }

  public initiatePaymentSetup(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.post('api/payment/initiatePayment', tenantPaymentInfo, null, true);
  }

  public initiateUpdatePaymentSetup(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/initiateUpdatePaymentSetup', tenantPaymentInfo, null, true);
  }

  public initiateUpdatePaymentSetupACH(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/initiateUpdatePaymentSetupACH', tenantPaymentInfo, null, true);
  }

  public initiateUpdatePaymentSetupACHRegistration(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/initiateUpdatePaymentSetupACHRegistration', tenantPaymentInfo, null, true);
  }
  
  public createSubsciption(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.post('api/payment/createSubsciption', tenantPaymentInfo, null, true);
  }

  public updateSubscription(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/updateSubsciption', tenantPaymentInfo, null, true);
  }

  public updateTenantACHInfo(tenantPaymentInfo: any): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/updateTenantACHInfo', tenantPaymentInfo, null, true);
  }

  public updateTenantCardInfo(tenantPaymentInfo: any): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/updateTenantCardInfo', tenantPaymentInfo, null, true);
  }

  public cancelSubscription(tenantPaymentInfo: TenantPaymentInfo): Observable<TenantPaymentInfo> {
    return this.apiClient.put('api/payment/cancelSubsciption', tenantPaymentInfo, null, true);
  }

  public getTenantPaymentInfo(): Observable<TenantPaymentInfo> {
    return this.apiClient.get('api/payment/getTenantPaymentInfo', null, null, true);
  }

  public GetTenantProductDetails(): Observable<ProductInfo> {
    return this.apiClient.get('api/payment/TenantProductDetails', null, null, true);
  }

  public GetTenantProductDetailRegistration(): Observable<ProductInfo> {
    return this.apiClient.get('api/payment/TenantProductDetailRegistration', null, null, true);
  }

  public verifyAchMicroDeposits(request): Observable<TenantPaymentInfo> {
    return this.apiClient.post('api/payment/verifyAchMicroDeposits', request, null, true);
  }

  public insertAchVerification(request): Observable<number> {
    return this.apiClient.post('api/payment/insertAchVerification', request, null, true);
  }

  public getPendingAchVerification() {
    return this.apiClient.get('api/payment/getPendingAchVerification',null,null, true);
  }

  public getSetupIntentClientSecret(setupIntentId) {
    return this.apiClient.get(`api/payment/getSetupIntentClientSecret?setupIntentId=${setupIntentId}`, null, null, true);
  }

  public checkAchStatus(setupIntentId) {
    return this.apiClient.get(`api/payment/checkachstatus/${setupIntentId}`, null, null, false);
  }

  public makePaymentMethodPrimary(paymentMethodId: string) {
    return this.apiClient.post(`api/payment/makePaymentMethodPrimary/${paymentMethodId}`, paymentMethodId, null, true);
  }

  public createPaymentActivityAuditLog(paymentActivtiyAuditLog) {
    return this.apiClient.post(`api/payment/createPaymentActivityAuditLog`, paymentActivtiyAuditLog, null, false);
  }

  public getTenantACHSetting() {
    return this.apiClient.get(`api/payment/getTenantACHSetting`, null, null, false);
  }
}
